"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.SelectCreateItem = exports.SelectEmptyItem = exports.SelectLoadingItem = exports.SelectHelperMenuItem = exports.SelectMenuItem = void 0;
var react_1 = __importDefault(require("react"));
var i18n_1 = require("../../../i18n");
var styles_1 = require("../../../styles");
var Spinner_1 = require("../../Spinner");
function SelectMenuItem(props) {
    var style = props.style, selected = props.selected, onKeyDown = props.onKeyDown, rest = __rest(props, ["style", "selected", "onKeyDown"]);
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    return (react_1.default.createElement("li", __assign({ className: css(classes.item, selected && classes.selected, style), "aria-selected": selected ? 'true' : 'false' }, rest)));
}
exports.SelectMenuItem = SelectMenuItem;
function SelectHelperMenuItem(props) {
    var theme = styles_1.useTheme();
    return (react_1.default.createElement(SelectMenuItem, __assign({ style: {
            background: theme.pallete.surface.background,
            paddingTop: '0.25rem',
            paddingBottom: '0.25rem',
            cursor: 'initial',
        } }, props)));
}
exports.SelectHelperMenuItem = SelectHelperMenuItem;
function SelectLoadingItem(props) {
    var theme = styles_1.useTheme();
    var locale = i18n_1.useLocale();
    return (react_1.default.createElement(SelectHelperMenuItem, __assign({}, props),
        locale.select.loadingItem,
        react_1.default.createElement(Spinner_1.Spinner, { style: { color: theme.pallete.primary.main, float: 'right' } })));
}
exports.SelectLoadingItem = SelectLoadingItem;
function SelectEmptyItem(props) {
    var locale = i18n_1.useLocale();
    return react_1.default.createElement(SelectHelperMenuItem, __assign({}, props), locale.select.emptyItem);
}
exports.SelectEmptyItem = SelectEmptyItem;
function SelectCreateItem(props) {
    var locale = i18n_1.useLocale();
    return react_1.default.createElement(SelectHelperMenuItem, __assign({}, props), locale.select.createItem);
}
exports.SelectCreateItem = SelectCreateItem;
exports.createStyles = function (theme) { return ({
    item: __assign(__assign({}, theme.typography.variant('main')), { borderBottom: "1px solid " + theme.pallete.divider, cursor: 'pointer', padding: '0.5rem 0.5rem', transition: '.1s ease', '&:last-of-type': {
            borderBottom: 'none',
        }, '&:hover': {
            background: theme.pallete.surface.background,
        }, '&:focus': {
            outline: 0,
            borderRadius: 3,
            boxShadow: styles_1.focusBoxShadow(theme, 'primary', 'inset'),
        } }),
    selected: {
        outline: 0,
        background: theme.pallete.surface.background,
    },
}); };
//# sourceMappingURL=SelectMenuItem.js.map